import React from 'react';
import { Box } from '@qga/roo-ui/components';

import {
  NUMBER,
  OVERSEA_NUMBER,
  OVERSEA_TEXT,
  TEXT,
} from '@/components/ContactUs';
import Link from '@/components/Link';

const CallUs = () => (
  <Box>
    <Box fontSize={['md', null, 'lg']} fontWeight="bold">
      <Link.Text href={`tel:${NUMBER}`}>{TEXT}</Link.Text>
    </Box>
    <Box>
      Outside Australia:{' '}
      <Link.Text href={`tel:${OVERSEA_NUMBER}`}>{OVERSEA_TEXT}</Link.Text>
    </Box>
  </Box>
);

export default CallUs;
